import { parseCurrency } from '@helper/parseCurrency'

export const parseFollowUpOtbData = (data: any[]): any[] => {
  const res = []

  let auxCount = 0
  for (const item of data) {
    res.push({
      'index-index': auxCount,
      // 'periodo-descricao': item.periodo.descricao,
      'empresa-codigo': item.empresaId,
      'produto-codigo': item.produtoId,
      'produto-descricao': item.produtoDescricao,
      'gerente-categoria-codigo': item.gerenteCategoriaId,
      'gerente-categoria-descricao': item.gerenteCategoriaDescricao,
      'gerente-produto-codigo': item.gerenteProdutoId,
      'gerente-produto-descricao': item.gerenteProdutoDescricao,
      'categoria-compacta-codigo': item.categoriaCompactaId
        ? item.categoriaCompactaId
        : '',
      'categoria-compacta-descricao': item.categoriaCompactaDescricao
        ? item.categoriaCompactaDescricao
        : '',
      'categoria-codigo': item.categoriaId ? item.categoriaId : '',
      'categoria-descricao': item.categoriaDescricao
        ? item.categoriaDescricao
        : '',
      // 'loja-codigo': item.lojaId ? item.lojaId : '',
      // 'loja-descricao': item.loja ? item.loja.descricao : '',
      'mundo-codigo': item.mundoId ? item.mundoId : '',
      'mundo-descricao': item.mundoDescricao ? item.mundoDescricao : '',
      'indicador-estoque-inicial': parseCurrency({
        value: item.estoqueInicialEmCusto,
        country: 'pt-br' //
      }),
      'indicador-estoque-atual': parseCurrency({
        value: item.estoqueAtualEmCusto,
        country: 'pt-br' //
      }),
      // 'indicador-rec-mes': parseCurrency({
      //   value: item.recebidos ? item.recebidos : 0,
      //   country: 'pt-br'
      // }),
      'indicador-vd-real': parseCurrency({
        value: item.vendasRealizadasEmCusto,
        country: 'pt-br' //
      }),
      // 'indicador-areceber': parseCurrency({
      //   value: item.recebimentosProgramados,
      //   country: 'pt-br'
      // }),
      'indicador-vd-planej-pcl': parseCurrency({
        value: item.vendasProjetadasEmCusto,
        country: 'pt-br'
      }),
      'indicador-vd-planej-proj': parseCurrency({
        value: item.estoqueProjetadoEmCusto,
        country: 'pt-br'
      }),
      // 'indicador-vd-planej-proj': parseCurrency({
      //   value: item.estoquePlanejadoEmCusto,
      //   country: 'pt-br'
      // }),
      // 'indicador-open-to-by': parseCurrency({
      //   value: item.openToBuy ? item.openToBuy : 0,
      //   country: 'pt-br'
      // }),
      'indicador-estoque-final-ajust': parseCurrency({
        value: item.quantidadeAReceberEmCusto,
        country: 'pt-br'
      })
    })
    auxCount++
  }

  return res
}
